import styled from "styled-components";
import {colors} from "../../common/colors";

type Props = {
  type?: 'submit'|'button';
  text: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export default function Button(props:Props) {
  return (
    <Container
      type={props.type}
      onClick={props.onClick}
      className={props.className}
      disabled={props.disabled}
    >
      {props.text}
    </Container>
  )
}

const Container = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  cursor: pointer;
  
  &.form-submit {
    background-color: ${colors.button.blue};
    font-size: 18px;
    font-weight: 700;
    color: #FFF;
    border-radius: 12px;
    &:disabled {
      background-color: ${colors.darkBlue};
    }
    &:active {
      transform: scale(0.98);
    }
  }
`